export default "__VITE_ASSET__Bbd8Alfq__"